var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.527 21.3158C23.4802 21.3158 26.6849 18.1111 26.6849 14.1579C26.6849 10.2047 23.4802 7 19.527 7C15.5738 7 12.3691 10.2047 12.3691 14.1579C12.3691 18.1111 15.5738 21.3158 19.527 21.3158Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7891 11.1892C26.4267 10.2285 27.3568 9.49856 28.4417 9.10757C29.5265 8.71658 30.7084 8.68528 31.8124 9.01831C32.9164 9.35135 33.8838 10.031 34.5714 10.9567C35.2591 11.8824 35.6304 13.0048 35.6304 14.158C35.6304 15.3111 35.2591 16.4336 34.5714 17.3593C33.8838 18.2849 32.9164 18.9646 31.8124 19.2976C30.7084 19.6307 29.5265 19.5994 28.4417 19.2084C27.3568 18.8174 26.4267 18.0875 25.7891 17.1267",
    stroke: "#2CE100",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5263 41C26.4444 41 32.0526 37.7953 32.0526 33.8421C32.0526 29.8889 26.4444 26.6842 19.5263 26.6842C12.6082 26.6842 7 29.8889 7 33.8421C7 37.7953 12.6082 41 19.5263 41Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6309 28.4736C38.7696 29.1626 40.9993 30.9055 40.9993 32.9473C40.9993 34.7905 39.1848 36.3885 36.5256 37.1884",
    stroke: "#2CE100",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.70592eb608fe3ed690270e87858ed15b.svg";
export { ForwardRef as ReactComponent };